import {TThemeEditorContext} from './types';
import React from 'react';

export default React.createContext<TThemeEditorContext | undefined>(undefined);
